import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePartnerLocations } from './normalize';

export const fetchPartnerLocations = createProvider(api.fetchPartnerLocations)
  .andThen((res) => normalizePartnerLocations(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
